import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";
import { SkeletonRows } from "./SkeletonRows.jsx";
import { DeviceListSkeleton } from "./DeviceListSkeleton.jsx";

export function DevicesRouteSkeleton() {
  const { c, dark } = useThemeSlice();
  const cardLift = dark
    ? "0 20px 42px rgba(0,0,0,.34)"
    : "0 16px 36px rgba(15,23,42,.10)";

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: 14 }}>
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          flex: 1,
          minHeight: 0,
          display: "flex",
          overflow: "hidden",
          boxShadow: cardLift,
        }}
      >
        <aside style={{ width: 280, flexShrink: 0, borderRight: `1px solid ${c.cardBdr}`, padding: "12px 14px 10px" }}>
          <SkeletonBlock height={36} style={{ marginBottom: 10 }} />
          <DeviceListSkeleton />
        </aside>
        <div style={{ flex: 1, padding: "20px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
          <SkeletonBlock width={200} height={20} />
          <SkeletonBlock width={280} height={14} />
          <SkeletonRows count={5} height={36} gap={10} style={{ marginTop: 8 }} />
        </div>
      </div>
    </div>
  );
}
